import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JdGridDirective } from './jd-grid.directive';
import { JdColDirective } from './jd-col.directive';
import { JdRowDirective } from './jd-row.directive';
import { JdRowExpDirective } from './jd-row-exp.directive';
import { JdGridExpDirective } from './jd-grid-exp.directive';
import { JdColExpDirective } from './jd-col-exp.directive';

const EXPORT_DECS = [
  JdColDirective,
  JdGridDirective,
  JdRowDirective,
  JdRowExpDirective,
  JdGridExpDirective,
  JdColExpDirective,
];

@NgModule({
  imports: [CommonModule],
  declarations: [...EXPORT_DECS],
  exports: [...EXPORT_DECS]
})
export class JdGridModule {}
